import React from 'react';
import { NavLink } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import { AiOutlineLogout } from 'react-icons/ai';
import logo from '../logo-estep.png';
import { isAdmin, isManager } from '../service/authService';

const Navigation = (props) => {
   const handleLogout = () => {
      localStorage.removeItem('username');
      localStorage.removeItem('user');
      localStorage.removeItem('roles');
      window.location = '/';
   };
   // const roles = JSON.parse(localStorage.getItem('roles'));
   const checkAdmin = isAdmin();
   const checkReport = isAdmin() || isManager();
   const checkAccountManager = isManager();
   console.log(checkAccountManager);
   return (
      <Navbar collapseOnSelect expand='lg' className='navbar navbar-dark' style={{ backgroundColor: '#20508e' }}>
         <Navbar.Brand>
            <NavLink className='navbar-brand' to='/s'>
               <img src={logo} className='logo-header' alt={'Logo'} />
            </NavLink>
         </Navbar.Brand>
         <Navbar.Toggle aria-controls='responsive-navbar-nav' />
         <Navbar.Collapse id='responsive-navbar-nav'>
            <Nav className='mr-auto'>
               {checkAdmin && localStorage.getItem('username') && (
                  <>
                     <NavLink className='nav-item nav-link active' to='/DashBoard'>
                        DashBoard
                     </NavLink>
                  </>
               )}
               {localStorage.getItem('username') && !checkAccountManager && (
                  <>
                     <NavLink className='nav-item nav-link' to='/RequestHistory'>
                        Request Logs
                     </NavLink>
                     <NavLink className='nav-item nav-link' to='/SalesHistory'>
                        Sales History
                     </NavLink>
                     <NavLink className='nav-item nav-link' to='/PaymentHistory'>
                        Payment History
                     </NavLink>
                  </>
               )}
               {checkReport && localStorage.getItem('username') && (
                  <>
                     <NavLink className='nav-item nav-link' to='/EndDayHistory'>
                        Admin
                     </NavLink>
                  </>
               )}
               {localStorage.getItem('username') && (
                  <button onClick={handleLogout} className='btn btn-sm text-light'>
                     <AiOutlineLogout /> Logout
                  </button>
               )}
            </Nav>
         </Navbar.Collapse>
      </Navbar>
   );
};

export default Navigation;
